module.exports = __webpack_public_path__ + "static/assets/7c996326bb3874d8e4a9145544f4e4f2.png";